export enum AccessLevel {
    PRIVATE = "private",
    RESTRICTED = "restricted",
    PUBLIC = "public",
}